module.exports = __webpack_public_path__ + "static/media/rundkolben_antwort1.2f58c4dd.png";